import {
  useStyle 
} from "@/classify"
import {
  useToasts 
} from "@/hooks/Toasts/useToasts"
import React from "react"
import Toast from "./toast"
import defaultClasses from "./toastContainer.module.css"

/**
 * A container for toast notifications.
 *
 * This component must be a child, nested or otherwise, of a
 * ToastContextProvider component.
 *
 * @typedef ToastContainer
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays toast notification data.
 */
const ToastContainer = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const [{
    toasts 
  }] = useToasts()

  // Given a map of toasts each with a property "timestamp", sort and display
  // based on the timestamp.
  const sortByTimestamp = ([, toastA], [, toastB]) => toastA.timestamp - toastB.timestamp

  const centerToastElements = Array.from(toasts)
    .filter(([, toast]) => toast.position === "center")
    .sort(sortByTimestamp)
    .map(([id, toast]) => {
      const key = toast.isDuplicate ? Math.random() : id

      return <Toast key={key} {...toast} />
    })

  const rightBottomToastElements = Array.from(toasts)
    .filter(([, toast]) => (toast.position || "rightBottom") === "rightBottom")
    .sort(sortByTimestamp)
    .map(([id, toast]) => {
      const key = toast.isDuplicate ? Math.random() : id

      return <Toast key={key} {...toast} />
    })

  return (
    <>
      <div id='toast-root' className={classes.root}>
        {rightBottomToastElements}
      </div>
      <div
        id='toast-center-root'
        className='gap-y-xs lg_min-w-auto fixed left-1/2 top-1/2 z-[1001] grid min-w-full -translate-x-1/2 -translate-y-1/2'
      >
        {centerToastElements}
      </div>
    </>
  )
}

export default ToastContainer
